module.exports = __webpack_public_path__ + "images/a3d02549c988c090e828ed8168b379ec.png";